import styled from 'styled-components'

export const WhiteWrapper = styled.div`
  background-color: #fff;
  border-radius: 8px;
  padding: 24px;
`

export const SearchWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 8px 0px 16px;
`

export const TimelineWrapper = styled.div`
  padding-top: 24px;
  .ant-timeline.ant-timeline-label .ant-timeline-item-label {
    width: 85px;
  }
  .ant-timeline.ant-timeline-label .ant-timeline-item-tail, .ant-timeline.ant-timeline-label .ant-timeline-item-head {
    inset-inline-start: 105px;
  }
  .ant-timeline.ant-timeline-label .ant-timeline-item-left .ant-timeline-item-content {
    inset-inline-start: 100px;
    width: calc(100% - 120px);
  }
`

export const SegmentListWrapper = styled.div`
  padding-bottom: 8px;
  border-bottom: 1px solid rgba(0,0,0,.1);
  .ant-statistic .ant-statistic-content {
    font-size: 14px;
  }
`

export const SegmentList = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0px 24px 6px 2px;
`

export const BackButton = styled.div`
  padding: 8px 8px 16px;
  font-size: 20px;
  font-weight: 600;
  display: flex;
  gap: 10px;
  .anticon {
    font-size: 18px;
    cursor: pointer;
  }
`

export const FormButton = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 32px;
  gap: 8px;
`

export const SettingWrapper = styled.div`
  display: flex;
  background-color: #fff;
  border-radius: 8px;
  font-size: 14px;
`

export const BasicSettingWrapper = styled.div`
  width: ${({ reverse }) => reverse ? 'calc(100% - 320px)' : '360px'};
  padding: 24px;
  border-right: 1px solid rgba(0,0,0,.1);

  .ant-checkbox-group {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 2px 0px 12px;
  }
  .ant-checkbox-group-item {
    margin-inline-start: 0;
  }
`

export const CustomSettingWrapper = styled.div`
  width: ${({ reverse }) => reverse ? '360px' : 'calc(100% - 320px)'};
  padding: 24px;

  .ant-empty-description {
    color: rgba(0,0,0,.3);
  }
`

export const SubTitle = styled.div`
  font-weight: 600;
  padding-bottom: ${({ section }) => section ? '8px' : '24px'};
  cursor: default;
`

export const UnderlineBoldTxt = styled.div`
  font-weight: 500;
  border-bottom: 1px solid #000;
  line-height: 18px;
  margin-bottom: 8px;
  width: fit-content;
`

export const RoundedTag = styled.div`
  margin: 4px 0px;
  width: fit-content;
  padding: 1px 8px;
  border-radius: 16px;
  background-color: rgba(0,0,0,.75);
  color: #fff;
  font-size: 12px;
  display: flex;
  gap: 4px;
  .ant-statistic .ant-statistic-content {
    color: #fff;
    font-size: 12px;
  }
`

export const BasicInfoWrapper = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  gap: 16px;

  .ant-statistic .ant-statistic-title {
    margin-bottom: 0px;
    color: rgba(0,0,0,.3)
  }
  .ant-statistic .ant-statistic-content {
    color: #000;
    font-size: 14px;
  }
`
